import { useAppSelector } from '@/app/store/hooks';
import { selectIsSupplierSession } from '@/features/authentication';
import { Layout } from './Layout';
import { SupplierLayout } from './SupplierLayout';

/**
 * The shell the signed-in session works in: the staff shell, or -- for a supplier signed in to the Supplier Bid
 * Quotation portal (2026-10-23) -- the supplier's own. Decided by the access token's own claim, so a user's session
 * renders exactly the shell it always has.
 */
export function AppShell() {
  const isSupplier = useAppSelector(selectIsSupplierSession);
  return isSupplier ? <SupplierLayout /> : <Layout />;
}
